/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { getUserName, UserProfileResource } from '@alfa-client/user-profile-shared';
import { Component, input, InputSignal, output } from '@angular/core';
import { StateResource } from '@common/tech-shared';

@Component({
  selector: 'alfa-user-profile-in-header',
  templateUrl: './user-profile-in-header.component.html',
  standalone: false,
})
export class UserProfileInHeaderComponent {
  public readonly currentUserResource = input<StateResource<UserProfileResource>>();
  public readonly meinProfilUrl: InputSignal<string> = input<string>();

  public readonly logoutEmitter = output<void>();

  public get buttonTooltip(): string {
    return this.currentUserResource() ? `Benutzerkonto von ${getUserName(this.currentUserResource().resource)}` : 'Benutzerkonto';
  }
}
